/** Shared copy and service data for AHS (An Hour Solution) pages */

export const AHS_CONTACT = {
  phone: "033 40621270",
  fax: "033 40621270",
  hours: "Mon - Sat : 09:00 - 18:00",
  openingHours: {
    weekdays: "Mon - Fri : 09:00 - 18:00",
    saturday: "Saturday : 09:00 - 15:00",
    sunday: "Sunday : Closed",
  },
  address: "BB-1, Ground Floor, Sector-I, Salt Lake, Kolkata-700064",
  email: "anhr_solution@facility-groups.com",
  tagline: "Your one stop destination for facility management and domestic services in Kolkata.",
  aboutSnippet:
    "Have all hassle free services at one point. No need to call separately for plumbing, carpentry, electrical, AC, car wash, housekeeping, security services and more — just call us and we will reach you as per your expected timings.",
  mapEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3684.456!2d88.4095!3d22.5806!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a0277138b8fae0b%3A0x2deb595ea5b5c9f4!2sSalt%20Lake%20City%2C%20Kolkata%2C%20West%20Bengal!5e0!3m2!1sen!2sin!4v1710000000000!5m2!1sen!2sin",
  mapLink: "https://www.google.com/maps/search/?api=1&query=BB-1+Sector+I+Salt+Lake+Kolkata+700064",
  branches: [
    {
      region: "Assam",
      company: "AN HOUR SOLUTION PRIVATE LIMITED",
      lines: [
        "Shaktigarh Bye Lane No. 2",
        "Bhangagarh",
        "Kamrup Guwahati",
        "Kamrup",
        "Assam 781005",
      ],
      phones: ["8100224301", "7044724365"],
    },
    {
      region: "Odisha",
      company: "AN HOUR SOLUTION PRIVATE LIMITED",
      lines: [
        "METRO SATELITY CITY",
        "D-70, PHASE-2",
        "Bhubaneswar",
        "Khordha",
        "Odisha 752101",
      ],
      phones: ["8100224301", "7044000414", "7044724365"],
    },
  ],
};

export const AHS_CLIENT_LOGOS = [
  { img: "/assets/img/png/logos/Avani.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/Bandhan.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/EsselMining.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/FIS50yrsLogo.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/Gulf.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/IMPEnergy.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/Indusind.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/Insync.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/JSWSteel.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/PNB.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/RelianceCommunication.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/SonaKhazana.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/TataCommunications.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/godrej.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/preconet.png", target: "_self", link: "#" },
  { img: "/assets/img/png/logos/DakshineswarTemple.JPG", target: "_self", link: "#" },
];

export const majorClientsData = [
  {
    sector: "Banking & Financial",
    service: "Security & Manpower Services",
    icon: "feather-credit-card",
    clients: [
      "Hitachi Payment Service Pvt Ltd",
      "HRBC",
      "Mahindra & Mahindra Financial Service Ltd",
      "SBI General Insurance Company Ltd.",
      "SBI Life Insurance Company Ltd.",
      "Star Union Dai-Ichi Life Insurance Company",
      "HDFC Bank",
      "Bandhan Bank",
    ],
  },
  {
    sector: "Govt Sector",
    service: "Security & Manpower Services",
    icon: "feather-flag",
    clients: [
      "The Paschimanchal Unnayan Parisad",
      "WBSEDCL",
    ],
  },
  {
    sector: "Corporate Sector",
    service: "Security & Manpower Services",
    icon: "feather-briefcase",
    clients: [
      "Apeejay Business Centre Pvt. Ltd",
      "Apeejay Oxford Bookstores Pvt. Ltd.",
      "Apeejay Pvt. Ltd.",
      "Chhaya Prakashani Ltd.",
      "CRC Exports Pvt. Ltd.",
      "Godrej Properties Ltd",
      "GTL Infrastructure Ltd",
      "Khadim India Ltd.",
      "Lakhotia Infrastructure Pvt. Ltd.",
    ],
  },
  {
    sector: "Holy Places",
    service: "Security Services",
    icon: "feather-heart",
    clients: [
      "Dakhineswar Kali Temple & Debottar Estate",
    ],
  },
  {
    sector: "Educational Institutes",
    service: "Security Services",
    icon: "feather-book-open",
    clients: [
      "Arts Acre Foundation",
      "Poder Charity Trust",
    ],
  },
  {
    sector: "Logistics",
    service: "Security & Manpower Services",
    icon: "feather-truck",
    clients: [
      "Leopard Trans Llp",
      "Omni Astra Pvt. Ltd.",
      "Purnatha Investment Advisers Pvt. Ltd",
      "Quality Concern",
      "Sastasundar Healthbuddy Ltd",
      "Signature Management Services Forum",
      "Spectrum Storage Solutions Pvt. Ltd.",
      "ATC Trade Co Ordinator Pvt. Ltd.",
      "Atlas Logistics Pvt. Ltd.",
      "Blue Dart Express Ltd",
      "Wan Hai Lines (India) Pvt. Ltd.",
    ],
  },
  {
    sector: "Residential Complex",
    service: "Security Services",
    icon: "feather-home",
    clients: [
      "Club Town Greens Residents Association",
      "GKA Estates",
      "Happy Awasan LLP",
      "Lake City Abasik Samity",
      "Paharpur Realty Pvt. Ltd.",
    ],
  },
  {
    sector: "Industries",
    service: "Security Services",
    icon: "feather-settings",
    clients: [
      "Adeline Pharmaceuticals Pvt Ltd.",
      "Alom Extrusions Ltd.",
      "Vitamed Healthcare Pvt Ltd.",
      "Calsoft Pvt. Ltd.",
      "Yuksom Breweries Ltd",
      "ZTE Telecom India Pvt Ltd",
    ],
  },
  {
    sector: "Showroom",
    service: "Security & HK Services",
    icon: "feather-shopping-bag",
    clients: [
      "Gulf Oil Lubricants India Ltd.",
      "Himadri Speciality Chemical Ltd.",
      "Kamals Cake & Confectionery Pvt Ltd.",
      "Kamals Ice Cream & Industries Pvt Ltd.",
      "Kaniska Engineering Industries Llp",
      "Raj Laxmi Marketing Pvt Ltd.",
      "RBA Ferro Industries Pvt Ltd.",
      "Regent Electro-Mech Pvt.Ltd",
      "Rhino Agencies Ltd.",
      "Shyama Polytex Pvt Ltd",
      "Anjali Jewellers Pvt.Ltd",
      "H M Diwan Jewellers Pvt. Ltd.",
      "M/S Primarc Retail Stores Pvt. Ltd.",
      "Modi Motor Works",
      "Sri Annapurna Textiles",
      "The Janapriya Jewellers",
    ],
  },
  {
    sector: "Warehouse",
    service: "Security & HK Services",
    icon: "feather-package",
    clients: [
      "Ashok Leyland Ltd.",
      "Proconnect Supply Chain Solutions Ltd.",
      "Spectrum Storage Solutions Pvt. Ltd.",
      "Aeropict Logistics Solution Pvt. Ltd.",
      "M/S Manas Lifestyle Pvt Ltd",
      "Titagarh Rail Systems Ltd.",
    ],
  },
  {
    sector: "Medical & Hospitality",
    service: "Security & HK Services",
    icon: "feather-activity",
    clients: [
      "Mymd Healthcare Pvt.Ltd",
      "Palsons Derma Pvt. Ltd",
      "Peerless Hospital",
      "Christian Hospital Bissamcuttack",
    ],
  },
];

export const whyChooseUsData = [
  {
    icon: "line-icon-Globe text-[#2ed47c] text-[40px]",
    title: "High quality services",
    content:
      "We understand your requirements and keep your satisfaction above all to create a wonderful long term partnership.",
    linkTitle: "OUR SERVICES",
    link: "/page/our-services",
  },
  {
    icon: "line-icon-Gear-2 text-[#2ed47c] text-[40px]",
    title: "One stop destination",
    content:
      "We have the technical and management capability to provide end to end service ranging from security and surveillance to repair and maintenance at any geographic location.",
    linkTitle: "OUR SERVICES",
    link: "/page/our-services",
  },
  {
    icon: "line-icon-Like-2 text-[#2ed47c] text-[40px]",
    title: "Certified expert",
    content:
      "One of the very few companies in India to have all the required certification by the Government of India.",
    linkTitle: "OUR SERVICES",
    link: "/page/our-services",
  },
  {
    icon: "line-icon-Money-Bag text-[#2ed47c] text-[40px]",
    title: "Affordable pricing",
    content:
      "We provide best in class services at a price that ensures the best value for money you can get.",
    linkTitle: "OUR SERVICES",
    link: "/page/our-services",
  },
];

export const homeFeaturedServices = [
  {
    title: "Security Service",
    subtitle: "Professional guards",
    img: "/assets/img/jpg/security420.jpg",
    imgLink: "/page/our-services",
    btnTitle: "Learn more",
    btnLink: "/page/our-services",
    titleLink: "/page/our-services",
    icon: "fas fa-arrow-right",
  },
  {
    title: "Facility Management",
    subtitle: "Tailored solutions",
    img: "/assets/img/jpg/guesthouse420.jpg",
    imgLink: "/page/our-services",
    btnTitle: "Learn more",
    btnLink: "/page/our-services",
    titleLink: "/page/our-services",
    icon: "fas fa-arrow-right",
  },
  {
    title: "Housekeeping Services",
    subtitle: "Trained staff",
    img: "/assets/img/jpg/housekeeping420.jpg",
    imgLink: "/page/our-services",
    btnTitle: "Learn more",
    btnLink: "/page/our-services",
    titleLink: "/page/our-services",
    icon: "fas fa-arrow-right",
  },
  {
    title: "Domestic Services",
    subtitle: "On-demand support",
    img: "/assets/img/jpg/KitchenChimney1_420.jpg",
    imgLink: "/page/our-services",
    btnTitle: "Learn more",
    btnLink: "/page/our-services",
    titleLink: "/page/our-services",
    icon: "fas fa-arrow-right",
  },
];

export const homeServicesCarousel = [
  {
    img: "/assets/img/jpg/security420.jpg",
    title: "Security Service",
    number: "01",
    content:
      "Security management services that ensure your personal and business environment stays safe and secure.",
  },
  {
    img: "/assets/img/jpg/guesthouse420.jpg",
    title: "Facility Management",
    number: "02",
    content:
      "Personalized services combined with customized tailor made solutions that best suit your needs.",
  },
  {
    img: "/assets/img/jpg/housekeeping420.jpg",
    title: "Housekeeping Services",
    number: "03",
    content:
      "Professional, efficient and trustworthy housekeeping staff delivering the highest quality of work.",
  },
];

/** Full service catalogue from Docs/SERVICES.pdf — used by the Our Services detail section */
export const detailedServicesData = [
  {
    id: "security-management",
    title: "Security Management Services",
    img: "/assets/img/jpg/security420.jpg",
    summary:
      "Experienced security professionals who ensure your personal and business environment stays secure, with round-the-clock coverage.",
    intro: [
      "To ensure your personal and business security we provide security management services that ensure you secure environment. Our security management services ensure that your security needs are duly and timely met.",
      "We have security professionals carrying yrs. of experience who make you feel secured at their best. We provide trustworthy and proficient security services for all your security needs. Our professionals undergo rigorous training schedules to provide them with the skill to proficiently handle all manners of urgent situations.",
    ],
    sections: [
      {
        title: "Scope of Security Management Services",
        items: [
          {
            title: "Manual Frisking",
            content:
              "We provide educated well trained and smart guards for frisking and enforcing discipline in office premises. Our security guards are well trained in all security hazards including manually frisking guests and premises.",
          },
          {
            title: "Receiving incoming & outgoing material",
            content:
              "Our security staff is responsible for ensuring that the materials and equipment are received, stored, preserved, and handled in accordance with the specifications. Receiving incoming and outgoing material is also primary role of security professionals.",
          },
          {
            title: "Attending Calls & Directing the same",
            content:
              "Our professionally trained personnel is committed to quality performance and experienced in effective communication and interpersonal skills. Our competent and trained workforce attends call on your behalf and further directs same to concerned person.",
          },
          {
            title: "Receiving Couriers & delivering same",
            content:
              "Our security staff individual’s job responsibility also includes receiving various documents and items through courier or post, maintaining their record and delivering the same to the designated person.",
          },
          {
            title: "Maintaining In & Out Registers",
            content:
              "Our security professional also maintains in and out registers for entire courier dispatch and receipts, all carriage inward and outward along with maintaining time in & out register for employees.",
          },
          {
            title: "Securing the building provinces & its assets",
            content:
              "With rapid expansion and transformation of Indian industries and businesses across the region the importance of maintaining and securing building provinces and its assets, has really grown. An Hour Solution Pvt. Ltd. Security staff extremely understands this need and takes personal interest in serving the clients.",
          },
        ],
      },
    ],
    closing: [
      "We provide round the clock services to cater your special needs of security management. Our security management services relieve you from various hassles and in return provide complete peace of mind. We are dedicated to provide you unsurpassed secure and promising environment.",
    ],
  },
  {
    id: "patrolling",
    title: "Patrolling Services",
    img: "/assets/img/jpg/security420.jpg",
    summary:
      "Uniformed patrol officers available 24/7 to deter vandalism, theft and trespassers while supporting emergency response.",
    intro: [
      "Our well-trained uniformed patrol officers can enhance your employees’ safety and reduce the risk of vandalism or theft on your property. Our private security patrol officers are trained to notice anything out of the ordinary — and to prevent problems before they start.",
      "Our patrol operations are available 24/7 to provide the continuous safety of your people and property. Our patrol personnel are trained to support you in a variety of ways, including:",
    ],
    sections: [
      {
        title: "Patrol support includes",
        bullets: [
          "Providing professional response to emergency situations.",
          "Providing safety and fire watch.",
          "Helping to promote a safe workplace environment.",
          "Performing set patrol services or random patrol patterns.",
          "Serving as stand-by for water leaks, power outages, special coverage needs.",
          "Conducting vehicle patrols, foot patrols, lock checks, interior and/or exterior checks and parking lot checks, lift & stair case check.",
        ],
      },
    ],
    closing: [
      "Our patrol officers help to deter vandalism, theft and trespassers on your property. Should the need arise, our patrol personnel are trained to coordinate quick notification of local law enforcement.",
    ],
  },
  {
    id: "housekeeping",
    title: "Housekeeping Services",
    img: "/assets/img/jpg/housekeeping420.jpg",
    summary:
      "Professional housekeeping staff, quality materials, and modern machines for banks, MNCs, retail, IT and more.",
    intro: [
      "We provide you professional, efficient and trustworthy House Keeping Staff. Our fully trained Housekeepers provide you the highest professional quality in the House Keeping works.",
    ],
    supplyScope: [
      "House Keeping-Staff",
      "Housekeeping-Materials",
      "Housekeeping-Machine And Equipment",
    ],
    sections: [
      {
        title: "House Keeping Staff",
        intro:
          "An Hour Solution Pvt. Ltd. is committed to offer best housekeeping services to each individual client. Our housekeeping program is designed in ideal manner that accomplish the complete requirement and need of our valuable clients at any time. We provide housekeeping services for banks, insurance companies, multinational companies, retail sector, stores, IT companies, construction companies and many more.",
        bullets: [
          "We provide professionally trained, uniformly dressed housekeeping staff, possessing good code of conduct.",
          "We also provide house-keeping staff, which can handle various types of machines being used for housekeeping purpose. We usually select staff having experience as a houseman in corporate sector.",
          "We have sufficient backup manpower at every station to cater absentee replacement immediately.",
          "We also provide supervisors to manage and control the team of workers. Supervisors are well versed with the housekeeping techniques and schedules and are provided with the mobile phones. They are capable to communicate with the client and understand their needs and requirements.",
        ],
        closing:
          "Our mission is to supply you with the personalized service at your ease as we know that each client’s housekeeping needs are different. Our commitment to you is to provide you housekeeping staff who meet your expectations. We are sure that with our pool of housekeepers and their arrangement skill we can offer you a service to fit both your budget and individual requirements.",
      },
      {
        title: "House Keeping Materials",
        content:
          "An Hour Solution Pvt. Ltd. housekeeping services are characterized by use of quality, eco-friendly and harmless products in housekeeping services. We use finer quality housekeeping materials manufactured by reputed companies. We use modern housekeeping material especially available for corporate housekeeping offices. Due to our well-organized housekeeping services, we have become quite popular in Regions of East.",
      },
      {
        title: "House Keeping Machine And Equipment",
        content:
          "An Hour Solution Pvt. Ltd. housekeeping services make your premises attractive inspire efficiency and add value to the property. We always use the best cleaning machines and equipment in our cleaning work. Every machine and equipment used by us is of good quality and cleans the surface of the area cleaned without any side effect.",
        bullets: [
          "Dust control mops, wet mops, yard brooms, feather dusters, cobweb removing brushes, dust pans, brooms, buckets, dusters, carpet brush, upholstery brushes, toilet brush and Aorta Rod for high rise glass cleaning.",
          "Floor scrubbing machines, buffing machines, floor polishing machines, wet and dry vacuum cleaners, high pressure jets, auto scrubbers, manual sweepers, backpack vacuum cleaners and more.",
        ],
      },
    ],
  },
  {
    id: "repair-maintenance",
    title: "Repair & Maintenance Services",
    img: "/assets/img/jpg/ElectricalServicing_420New.jpg",
    summary:
      "Electrical, plumbing, carpentry, civil, painting and electro-mechanical maintenance across Eastern India — on supervision or on-call basis.",
    intro: [
      "An Hour Solution Private Limited provides, thoroughly trained to tailor made with outstanding and an extensive range of repair and maintenance services, throughout Eastern India on the basis of skilled operating efficiencies.",
      "Our repair and maintenance services are popular amongst the clients, as these are excellent in quality and available at affordable prices. We possess perfect team of workers keeping up with client’s requirements to serve them in a best possible manner.",
      "We also provide customized services as per client's specified requirement. Our repair and maintenance services include electrical services, plumber services, and carpentry services along with painting jobs. We do the R & M on regular supervision basis as well as on call basis.",
    ],
    sections: [
      {
        title: "Scope of services for domestic & commercial",
        items: [
          {
            title: "Electrical Work",
            content:
              "We provide effective, pro-active and comprehensive services to suit your daily electrical demands within your organization which includes maintenance of the power points, power panels, light fixtures, fans, detection & rectification of abnormalities for the smooth functioning of the electrical system.",
          },
          {
            title: "Plumbing Work",
            content:
              "We provide plumbing services; individuals are dedicated to diagnose and rectify any fault as effectively and efficiently as possible. Our plumbing work services include repair, maintenance and changing of plumbing and sanitary fixtures including checking of supply lines.",
          },
          {
            title: "Carpentry Work",
            content:
              "We provide you skilled carpenters who have experience in all aspects of commercial carpentry work. Our Carpentry services include all facets of carpentry whether it is minor repair of wooden surfaces due to seasonal variation, changing of locks, hinges etc. or making and fixing of new wooden partitions, racks, cupboards, doors or changing of door and window glass.",
          },
          {
            title: "Civil Work",
            content:
              "To keep civil works structure and their components fully functional and safe, we undertake civil work thorough inspection procedure. Our civil work specialist team provides civil works coordinated maintenance and repair solutions.",
          },
          {
            title: "Painting and Polishing Jobs",
            content:
              "We have best specialized resources at your service for high class painting and polishing work. Our skilled & experienced persons for painting and polishing jobs undertake painting of walls and false ceilings, other parts of building structure along with polishing of wooden furniture and fixtures.",
          },
          {
            title: "Electro Mechanical Work",
            content:
              "Our Electro-Mechanical individuals are skilled professionals having broad knowledge and capability of performing superior quality Electro-Mechanical maintenance and repair services.",
            bullets: [
              "Electrical Maintenance",
              "DG Operation",
              "Water Treatment Plant Maintenance",
              "HVAC",
              "Control Room Operations",
              "Waste Management",
              "Chiller Maintenance",
              "UPS Maintenance",
              "AC AMC",
            ],
          },
        ],
      },
    ],
  },
  {
    id: "ac-amc",
    title: "AC AMC Services",
    img: "/assets/img/jpg/AC_repair420.jpg",
    summary:
      "On-site or on-call AC AMC support to keep air conditioning systems performing consistently and reliably.",
    intro: [
      "Backed by the experienced team of professionals, we offer outstanding range of AC AMC Service to our esteemed clients. Our services are used to increase the working capacity of A.C and maintain the consistent performances of the machinery. We are widely recommended among the clients for giving prompt, valued and reliable services. With the support of dedicated and trained personnel staff members, we have been to satisfy diverse requirements of the clients efficiently.",
    ],
    sections: [
      {
        title: "Features",
        bullets: [
          "Experienced professionals",
          "Timely execution",
          "Result oriented",
        ],
      },
    ],
    closing: [
      "These services can be provided by providing on site technicians or on call basis. Major works are generally undertaken after getting approval for the estimate.",
    ],
  },
];

/** Short cards / swiper summaries derived from the detailed catalogue */
export const corporateServicesData = detailedServicesData.map((service) => ({
  img: service.img,
  title: service.title,
  content: service.summary,
}));

export const corporateServiceNames = corporateServicesData.map((s) => s.title);

export const servicesSwiperData = corporateServicesData.map((s) => ({
  img: s.img,
  title: s.title,
  content: s.content,
}));
